import React from 'react';
import { defineMessages, t } from '@sm/intl';
import { createURL } from '@sm/utils';

import EndpageHeader from '~app/components/EndpageHeader';
import SimpleHero from '~app/components/SimpleHero';
import FortuneCallout from '~app/components/FortuneCallout';
import ProductsCalloutList from '~app/components/ProductsCalloutList';

import AudienceIconGreen from '~static/images/icons/audience-icon-green.svg';
import EnterpriseIconBlue from '~static/images/icons/enterprise-icon-blue.svg';

const COPY = defineMessages({
  ENDPAGE_HEADER_COPY: {
    id: 'SurveyThanks.RebrandExistingUser.EndpageHeaderCopy',
    defaultMessage: 'Thank you for taking this survey.',
    description: '[Type: Header][Vis: med] - Informs the viewer that this survey has just completed',
  },

  PRODUCT_CALLOUT_AUDIENCE_HEADING: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutAudienceHeader',
    defaultMessage: 'Survey your target market',
    description:
      '[Type: Header][Vis: med] - Tagline to help entice users to views click the cta below. The CTA leads to our Market Research, Audience - marketing pages',
  },
  PRODUCT_CALLOUT_AUDIENCE_BODY: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutAudienceBody',
    defaultMessage: 'SurveyMonkey Audience has millions of people ready to take your survey.',
    description: '[Type: Paragraph][Vis: med] - Gives context to the above Tagline',
  },
  PRODUCT_CALLOUT_AUDIENCE_CTA: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutAudienceCTA',
    defaultMessage: 'LEARN MORE',
    description: '[Type: Button][Vis: med] - The text for a button that leads users to an informational marketing page',
  },

  PRODUCT_CALLOUT_ENTERPRISE_HEADING: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutEnterpriseHeader',
    defaultMessage: 'Want more power and multiple users?',
    description: "[Type: Header][Vis: med] - Tag line introducing SurveyMonkey's Enterprise plan's value proposition",
  },
  PRODUCT_CALLOUT_ENTERPRISE_BODY: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutEnterpriseBody',
    defaultMessage: 'Get our most powerful features and make smarter decisions with SurveyMonkey Enterprise.',
    description:
      '[Type: Paragraph][Vis: med] - Expands and reiterate the value proposition for the SurveyMonkey Enterprise plan',
  },
  PRODUCT_CALLOUT_ENTERPRISE_CTA: {
    id: 'SurveyThanks.RebrandExistingUser.ProductCalloutEnterpriseCTA',
    defaultMessage: 'LEARN MORE',
    description:
      "[Type: Button][Vis: med] - The button text that leads users to a marketing page to learn more about SurveyMonkey's Enterprise plans",
  },

  FORTUNE_CALLOUT_COPY: {
    id: 'SurveyThanks.RebrandExistingUser.FortuneCalloutCopy',
    defaultMessage: '98% of the Fortune 500 rely on SurveyMonkey for People Powered Data',
    description: '[Type: Header][Vis: low] - A promotional statistic designed to show corporate trust and prestige',
  },
  FORTUNE_CALLOUT_CTA: {
    id: 'SurveyThanks.RebrandExistingUser.FortuneCalloutCTA',
    defaultMessage: 'CREATE SURVEY',
    description: "[Type: Button][Vis: high] - Fortune's CTA which encourages our users to create a survey",
  },
});

const RebrandExistingUser = () => {
  const utSource = 'survey_thanks';
  const utSource2 = 'rebrand_existing_user';

  const CALLOUT_ITEM_AUDIENCE = {
    icon: AudienceIconGreen,
    heading: t(COPY.PRODUCT_CALLOUT_AUDIENCE_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_AUDIENCE_BODY),
    href: createURL('/mp/audience/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_AUDIENCE_CTA),
    ctaColor: 'classic-sabaeus',
    name: 'audience',
    color: 'dark',
  };

  const CALLOUT_ITEM_ENTERPRISE = {
    icon: EnterpriseIconBlue,
    heading: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_HEADING),
    copy: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_BODY),
    href: createURL('/enterprise/', {
      ut_source: utSource,
      ut_source2: utSource2,
    }),
    cta: t(COPY.PRODUCT_CALLOUT_ENTERPRISE_CTA),
    ctaColor: 'classic-midnight',
    name: 'enterprise',
    color: 'dark',
  };

  return (
    <>
      <EndpageHeader copy={t(COPY.ENDPAGE_HEADER_COPY)} hasLogo headerColor="sabaeus" headerType="thanks" />
      <SimpleHero hideCTAs={false} />
      <ProductsCalloutList
        calloutItem1={CALLOUT_ITEM_AUDIENCE}
        calloutItem2={CALLOUT_ITEM_ENTERPRISE}
        utSource={utSource}
      />
      <FortuneCallout
        copy={t(COPY.FORTUNE_CALLOUT_COPY)}
        ctaText={t(COPY.FORTUNE_CALLOUT_CTA)}
        utSource={utSource}
        route="/create/"
        color="sabaeus"
        utSource2="rebrand_existing_user"
      />
    </>
  );
};

export default RebrandExistingUser;
